import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MigoCardComponent } from './migo-card.component';
import { MigoCardHeaderComponent } from './components/migo-card-header/migo-card-header.component';
import { MigoCardHeaderSuffixDirective } from './components/migo-card-header/migo-header-suffix';
import { MigoCardFooterComponent } from './components/migo-card-footer/migo-card-footer.component';
import { MigoCardContentComponent } from './components/migo-card-content/migo-card-content.component';

@NgModule({
  declarations: [
    MigoCardComponent,
    MigoCardHeaderComponent,
    MigoCardHeaderSuffixDirective,
    MigoCardFooterComponent,
    MigoCardContentComponent,
  ],
  imports: [CommonModule],
  exports: [
    MigoCardComponent,
    MigoCardHeaderComponent,
    MigoCardHeaderSuffixDirective,
    MigoCardFooterComponent,
    MigoCardContentComponent,
  ],
})
export class MigoCardModule {}
